<div mat-dialog-content>
  <p>Diesen Termin löschen?</p>
</div>
<div mat-dialog-actions>
  <button mat-stroked-button (click)="onNoClick()">Abbrechen</button>
  <button mat-stroked-button color="primary" (click)="onDeleteClick()" cdkFocusInitial>Löschen</button>
</div>
